import React from 'react'
import Module from '../modules/Module'
import DataSource from '../DataSource'
import Heading from '../components/Heading'
import CountrySearch from '../components/CountrySearch'
import ResponsiveTable from '../components/ResponsiveTable'
import Loader from '../components/Loader'
import globals from '../globals'

class MobileInternationalRates extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
            isLoaded: false,
            noResult: false,
            isLoadingRates: false,
            title: '',
            description: '',
            search: '',
            rates: [],
            freeCallsAndSMS: {}
        }

        this.noResults = [{ zone: 'no-results', country: 'No country found.', additional: '' }]
    }

    componentDidMount () {
        DataSource.getData('/api/getContent/mobile/internationalRates', response => {
            this.setState({
                title: response.title,
                description: response.description,
                isLoaded: true,
                freeCallsAndSMS: response.freeCallsAndSMS
            })
        })
        globals.pushGA4Events("pageLoad", {
            eventInfo: {
                pageName: "Mobile international rates",
                pageCategory: "Mobile",
                pageType: "Information"
            }
        });
    }

    handleChange (event) {
        this.setState({
            search: event.target.value,
            noResult: false
        }, this.getData.bind(this))
    }

    getData () {
        if (this.state.search.length > 1) {
            clearTimeout(this.timer)

            this.setState({
                isLoadingRates: true,
                rates: []
            })

            this.timer = setTimeout(() => {
                this.search(this.state.search)
            }, 500)
        }
    }

    search (search) {
        globals.pushEvent('gtm-Mobile-International-Rate-Search')
        DataSource.getData(`/api/searchMobileInternationalRates/${search}`, result => {
            this.setState({ isLoadingRates: false })

            if (result.length > 0) {
                this.setState({ rates: result })
            } else {
                this.setState({ noResult: true })
            }
        })
    }

    render () {
        const TableData = {
            headings: ['Destination', 'Zone', 'Price/min'],
            rows: this.state.rates
        }

        const Result = () => {
            if (this.state.isLoadingRates) {
                return <div className='w-100 text-center'><Loader /></div>
            } else if (this.state.noResult) {
                return <div className='text-center'>No results found for "{this.state.search}".</div>
            } else if (this.state.rates.length > 0) {
                return <ResponsiveTable data={TableData} />
            } else {
                return <div className='text-center'>Start typing the country to find the rates.</div>
            }
        }

        return (
            <Module isLoaded={this.state.isLoaded}>
                <div className='row'>
                    <div className='col-12 col-lg-8 offset-lg-2'>
                        <Heading title={this.state.title} description={this.state.description} className='text-center mb-3' />
                        <CountrySearch title='Find your rates:' search={this.state.search} countryList={[]} handleChange={this.handleChange.bind(this)} handleSelect={() => {}} />
                        {Result()}
                    </div>
                </div>
            </Module>
        )
    }
}

export default MobileInternationalRates



// WEBPACK FOOTER //
// ./resources/js/mobile/MobileInternationalRates.js